module.exports = __webpack_public_path__ + "images/sd-02-faq-desktop.png";